// @ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from '../../router-compat';
import { inject, observer } from "../../stores/mobx-compat";
import _ from 'lodash';

import CaptureLogo from '../ui/CaptureLogo';
import { navIcons } from '../ui/icons';
import Avatar from '../ui/Avatar';
import DropdownMenu, { MenuItem, MenuSection, MenuDivider } from '../ui/DropdownMenu';
import {
  ChevronUpIcon, SettingsIcon, CodeIcon, CreditCardIcon, LogOutIcon, EyeOffIcon,
} from '../ui/icons';
import { userRoleType } from '../../enums';

const SECTION_LABEL = {
  main: 'Main',
  insights: 'Insights',
  setup: 'Setup',
  account: 'Account',
  admin: 'Admin',
};

const SidebarInner = ({ store, location, routeConfigs, onNavigate, history }) => {
  const visible = routeConfigs.filter((r) => r.icon);
  const groups = _.groupBy(visible, (r) => r.group || 'main');
  const order = ['admin', 'main', 'insights', 'setup', 'account'];

  const { mobile } = store.ui;
  const { user } = store.auth;
  const userName = user.firstName ? `${user.firstName} ${user.lastName || ''}`.trim() : (user.email || '');
  const subline = user.company || (user.role === 'superadmin' ? 'Admin' : 'Workspace');

  const partner = store.initQueryParams.partner;
  const hidePayments = ['wix', 'shopify'].includes(partner);
  const isSpoofed = typeof window !== 'undefined' && localStorage.getItem('spoofed') === '1';

  const go = (path) => {
    history.push(path);
    if (onNavigate) onNavigate();
  };

  return (
    <aside
      className={`mov-side flex flex-col gap-6 bg-mov-paper sticky top-0 h-screen ${mobile ? '' : 'px-4 pb-5'}`}
      style={{ borderRight: '1px solid var(--mov-line)' }}
    >
      {!mobile && (
        <div
          className="flex items-center gap-2.5 h-[var(--mov-topbar-h)] -mx-4 px-4"
          style={{ borderBottom: '1px solid var(--mov-line)' }}
        >
          <CaptureLogo style={{ width: 130 }} />
        </div>
      )}

      <nav className="flex flex-col gap-5 flex-1 min-h-0 overflow-y-auto">
        {order.filter((g) => groups[g]).map((g) => (
          <div key={g} className="flex flex-col gap-0.5">
            <span
              className="mov-mono"
              style={{
                fontSize: 10,
                letterSpacing: '0.14em',
                textTransform: 'uppercase',
                color: 'var(--mov-ink-mute)',
                padding: '6px 0',
              }}
            >
              {SECTION_LABEL[g] || g}
            </span>
            {groups[g].map((cfg) => {
              const route = cfg.path.replace(/\/:.*\/*/g, '');
              const active = location.pathname.startsWith(route);
              const Icon = navIcons[cfg.icon] || navIcons.info;
              return (
                <Link
                  key={cfg.name}
                  to={route}
                  onClick={onNavigate}
                  className="flex items-center gap-2.5 transition-colors"
                  style={{
                    padding: '9px 4px',
                    borderRadius: 8,
                    color: active ? 'var(--mov-accent-ink)' : 'var(--mov-ink-soft)',
                    background: active ? 'var(--mov-accent-soft)' : 'transparent',
                    fontWeight: 500,
                    fontSize: 13.5,
                  }}
                  onMouseEnter={(e) => { if (!active) { e.currentTarget.style.background = 'var(--mov-paper-2)'; e.currentTarget.style.color = 'var(--mov-ink)'; } }}
                  onMouseLeave={(e) => { if (!active) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--mov-ink-soft)'; } }}
                >
                  <Icon size={16} />
                  {cfg.label || cfg.name}
                </Link>
              );
            })}
          </div>
        ))}
      </nav>

      <div style={{ borderTop: '1px solid var(--mov-line)', paddingTop: 12 }}>
        <DropdownMenu
          align="left"
          direction="up"
          width={224}
          className="!block w-full"
          trigger={(
            <button
              type="button"
              className="flex items-center gap-2.5 w-full text-left transition-colors"
              style={{
                background: 'transparent',
                border: 0,
                padding: '8px 4px',
                borderRadius: 8,
                cursor: 'pointer',
                color: 'var(--mov-ink)',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--mov-paper-2)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
            >
              <Avatar name={userName || 'User'} />
              <div className="min-w-0 flex-1">
                <b className="block font-semibold text-[13px] truncate">{userName || 'User'}</b>
                <span className="text-[11.5px] text-mov-ink-mute truncate block">{subline}</span>
              </div>
              <ChevronUpIcon size={14} className="text-mov-ink-mute shrink-0" />
            </button>
          )}
        >
          <MenuSection>Account</MenuSection>
          <MenuItem icon={SettingsIcon} onSelect={() => go('/settings')}>Settings</MenuItem>
          <MenuItem icon={CodeIcon} onSelect={() => go('/setup')}>Setup snippet</MenuItem>
          {!hidePayments && (
            <MenuItem icon={CreditCardIcon} onSelect={() => go('/payments')}>Payments</MenuItem>
          )}
          {(user.role === userRoleType.superadmin || isSpoofed) && (
            <>
              <MenuDivider />
              <MenuItem icon={EyeOffIcon} onSelect={() => store.admin.spoofClient(null)}>Exit spoof</MenuItem>
            </>
          )}
          <MenuDivider />
          <MenuItem icon={LogOutIcon} danger onSelect={store.auth.signOut}>Sign out</MenuItem>
        </DropdownMenu>
      </div>
    </aside>
  );
};

export default withRouter(inject('store')(observer(SidebarInner)));
